import React, { useContext, useMemo } from "react";
import CourseList from "screens/course/CourseList";
import { useEntity } from "student-front-commons/src/hooks";
import { PROFILE_SCHEMA } from "student-front-commons/src/schemas";
import WhitelabelContext from "student-front-commons/src/components/WhitelabelContext";
import {unionBy} from "lodash";

function CourseListContainer() {
  const whitelabelContext = useContext(WhitelabelContext);

  const profile = useEntity(PROFILE_SCHEMA, sessionStorage.getItem("id"));

  const defaultCourses = useMemo(() => {
    return [
      {
        id: "discovery",
        name: "Discovery",
        disabled: true,
      },
      {
        id: "adventures",
        name: "Adventures",
        disabled: true,
      },
    ];
  }, []);

  const courses = useMemo(() => {
    if (profile?.activeCourses && profile?.activeCourses.length) {
      if (!whitelabelContext.disableFlexgeCourse) {
        return unionBy(defaultCourses, profile.activeCourses, 'name').map((staticCourse) => {
          const studentCourse = profile.activeCourses.find((c) => c.name === staticCourse.name);
          if (studentCourse) {
            return {
              ...studentCourse,
              disabled: false,
            };
          }
          return staticCourse;
        });
      }

      return profile.activeCourses;
    }

    return !whitelabelContext.disableFlexgeCourse ? defaultCourses : [];
  }, [defaultCourses, whitelabelContext.disableFlexgeCourse, profile?.activeCourses]);


  return <CourseList isLoading={false} courses={courses} />;
}

export default CourseListContainer;
